import { createContext } from "react";

const NewsContext = createContext();

export default NewsContext;